import { __decorate } from "tslib";
import { FrontendFeaturePlugin, provideRootRoutes } from '@core/frontend-shared';
import { ClassName } from '@core/shared/class-name';
import * as i0 from "@angular/core";
let CmsFrontendAdminFeature = /*#__PURE__*/(() => {
  let CmsFrontendAdminFeature = class CmsFrontendAdminFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@common/cms/frontend-admin","featureId":"common-cms"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineMenuItems({
        adminToolbar: [{
          label: 'CMS',
          routerLink: 'cms',
          priority: 5,
          icon: 'book'
        }]
      });
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵCmsFrontendAdminFeature_BaseFactory;
        return function CmsFrontendAdminFeature_Factory(__ngFactoryType__) {
          return (ɵCmsFrontendAdminFeature_BaseFactory || (ɵCmsFrontendAdminFeature_BaseFactory = i0.ɵɵgetInheritedFactory(CmsFrontendAdminFeature)))(__ngFactoryType__ || CmsFrontendAdminFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: CmsFrontendAdminFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'cms',
          loadChildren: () => import('./cms-admin.module').then(m => m.CmsFrontendAdminModule)
        }])]
      });
    }
  };
  CmsFrontendAdminFeature = __decorate([ClassName("CmsFrontendAdminFeature")], CmsFrontendAdminFeature);
  return CmsFrontendAdminFeature;
})();
export { CmsFrontendAdminFeature };